import { Input } from '@monorepo/shared/componentsV2/Input';
import styled, { css } from 'styled-components';

export const inputWithWhiteBackground = css`
  .MuiInputBase-root {
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const StyledInput = styled(Input)`
  ${inputWithWhiteBackground}
`;

export const conditionalDateTimePickerStyles = css<{
  $isErrorTextShown: boolean;
}>`
  margin-bottom: ${({ $isErrorTextShown }) =>
    $isErrorTextShown ? '0' : '0.2rem'};
`;
